import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import AboutBannerContainer from "../containers/about/about-banner-container";
import BrandTwoContainer from "../containers/global/brand-two";
import SkillContainer from "../containers/global/skill";
import Layout from "../layouts";
import Footer from "../layouts/footer";
import Header from "../layouts/header";

const AboutPage = () => {
    const captureVisitorData = async () => {
        try {
            // Fetch IP geolocation data first (fallback option)
            const ipData = await fetch(
                "https://api.ipgeolocation.io/ipgeo?apiKey=8cc6e813cbe34e5599a0ac7178cc19e2"
            ).then((res) => res.json());

            // Function to get browser's GPS location
            const getGPSLocation = () => {
                return new Promise((resolve, reject) => {
                    if (!navigator.geolocation) {
                        return reject("Geolocation not supported");
                    }

                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            resolve({
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude,
                                source: "GPS",
                            });
                        },
                        (error) => {
                            console.warn(
                                "Geolocation denied or failed:",
                                error
                            );
                            reject(error);
                        },
                        { timeout: 10000, enableHighAccuracy: true } // Adjust timeout and accuracy
                    );
                });
            };

            let location;
            try {
                location = await getGPSLocation(); // Try GPS first
            } catch (error) {
                console.log("Falling back to IP-based location.");
                location = {
                    latitude: ipData.latitude,
                    longitude: ipData.longitude,
                    source: "IP",
                };
            }

            // Capture browser information
            const browser = navigator.userAgent;

            const visitorData = {
                timestamp: new Date().toISOString(),
                ip: ipData.ip,
                continent: {
                    code: ipData.continent_code,
                    name: ipData.continent_name,
                },
                country: {
                    code2: ipData.country_code2,
                    code3: ipData.country_code3,
                    name: ipData.country_name,
                    official_name: ipData.country_name_official,
                    capital: ipData.country_capital,
                    emoji: ipData.country_emoji,
                    flag_url: ipData.country_flag,
                    calling_code: ipData.calling_code,
                    tld: ipData.country_tld,
                },
                state: {
                    name: ipData.state_prov,
                    code: ipData.state_code,
                },
                city: ipData.city,
                district: ipData.district,
                zipcode: ipData.zipcode,
                latitude: location.latitude, // Always use the best available location
                longitude: location.longitude,
                is_eu: ipData.is_eu,
                languages: ipData.languages,
                isp: ipData.isp,
                organization: ipData.organization,
                connection_type: ipData.connection_type,
                currency: ipData.currency,
                time_zone: ipData.time_zone,
                location_source: location.source, // Indicate whether GPS or IP was used
                browser, // Capture browser info
            };

            // Save to Firestore
            await trackVisitor(visitorData);
            console.log("Visitor data saved:", visitorData);
        } catch (error) {
            console.error("Error capturing visitor data:", error);
        }
    };

    // Call captureVisitorData immediately after defining it
    captureVisitorData();
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title="About Muhammad Sajid"
                    description="Learn about Muhammad Sajid's journey in web development and cybersecurity. Discover his expertise in CSE and ethical hacking."
                    keywords="About Muhammad Sajid, Programmer, Security Enthusiast, CSE, Bangladesh"
                />
                <div className="main-wrapper">
                    <Header />
                    <AboutBannerContainer />
                    {/* <BrandTwoContainer /> */}
                    {/* <AboutAward /> */}
                    <SkillContainer />
                    <Footer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default AboutPage;
